import { render } from "./TopLevelPdfViewDetail.vue?vue&type=template&id=b7c3cefe"
import script from "./TopLevelPdfViewDetail.vue?vue&type=script&lang=js"
export * from "./TopLevelPdfViewDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Documents\\MetaLuxe\\projects\\mantaray-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__